/* eslint-disable react/jsx-no-bind */
import { h, Component } from 'preact';
import { Button } from '../../button';
import styles from './styles.module.scss';
import {
  Notification,
  NotificationsEmptyState,
  UnreadIcon,
  getMarkHandler,
} from './index';
import { UseCaretIcon } from '../../svg/icons/caret';

export class AllNotifications extends Component {
  render({
    notifications,
    totalUnreadCount,
    onMarkAsReadClicked,
    onGoBack,
    onLoadMore,
    hasMore,
    isLoadingMore,
  }) {
    const hasNotifications = notifications.length > 0;
    const unreadNotifications = notifications.filter((n) => !n.read);
    const handleScroll = (evt) => {
      const { scrollTop, scrollHeight, clientHeight } = evt.target;
      // start loading the next page shortly before the user hits the bottom
      if (
        hasMore &&
        !isLoadingMore &&
        scrollHeight - scrollTop - clientHeight < 150
      ) {
        onLoadMore();
      }
    };

    return (
      <div className={styles.allNotifications}>
        <div className={styles.allNotificationsHeader}>
          <div className={styles.backButtonRow}>
            <Button
              className={styles.backButton}
              onClick={onGoBack}
              location={'userMenu'}
              label={'notifications-back'}
              aria-label={'Back'}
            >
              <UseCaretIcon
                className={styles.backButtonIcon}
                width={12}
                height={12}
                fill="#222"
                stroke="#222"
                strokeWidth={2}
              />
            </Button>
          </div>
          <div className={styles.notificationsTitleContainer}>
            <div className={styles.notificationsTitle}>
              <span>Notifications</span>
              {totalUnreadCount > 0 && <UnreadIcon count={totalUnreadCount} />}
            </div>
            {unreadNotifications.length > 0 && (
              <Button
                className={styles.markAllAsReadButton}
                onClick={() =>
                  onMarkAsReadClicked(
                    unreadNotifications[0],
                    true,
                    unreadNotifications,
                  )
                }
                location={'userMenu'}
                label={'notification-read-all'}
              >
                Mark all as read
              </Button>
            )}
          </div>
        </div>
        <div className={styles.allNotificationsList} onScroll={handleScroll}>
          {hasNotifications ? (
            <div className={styles.notificationsContainer}>
              <ul>
                {notifications.map((notification, index) => (
                  <Notification
                    onClick={getMarkHandler(notification, onMarkAsReadClicked)}
                    location={'userMenu'}
                    label={'notification-read'}
                    index={index}
                    {...notification}
                  />
                ))}
              </ul>
              {isLoadingMore && (
                <div className={styles.notificationsLoadingMore}>
                  Loading more...
                </div>
              )}
            </div>
          ) : (
            <NotificationsEmptyState />
          )}
        </div>
      </div>
    );
  }
}
